import { useContext } from 'react';
import { EditorStateContext } from 'FeatureModules/ProductPage/Contexts/EditorStateContext';
import { EditorStateContextValues } from 'FeatureModules/ProductPage/Contexts/EditorStateContext';

const useEditorState = (): EditorStateContextValues => {
  return useContext(EditorStateContext);
};

export default useEditorState;
